import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { saveProjectColorPalette } from '../../../projects/project.actions';
import { getCurrentColorPalette } from '../../../projects/project.selector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { getCurrentOrgColorPalette } from '../../../organisation/organisation.selector';
import { ShapeService } from '../../shape/shape.service';

export interface ColorRow {
  name: string;
  code: string;
  hover?: boolean;
}
export type Colors = Array<ColorRow>;

@Component({
  selector: 'nw-color-palette-edit',
  templateUrl: './color-palette-edit.component.html',
  styleUrls: ['./color-palette-edit.component.scss'],
})
export class ColorPaletteEditComponent {
  @Output()
  exit = new EventEmitter();

  selectedLang = 'en';

  languages$: Observable<string[]>;
  languages: string[];

  orgColorPalette$: Observable<Colors>;

  langMap = {
    hu: 'hungarian',
    en: 'english',
    ger: 'german',
    esp: 'spanish',
    fr: 'french',
    it: 'italien',
    pl: 'polish',
  };
  palette$: Observable<Colors>;
  palette: Colors;
  colorPalette: Record<string, string> = {};
  orgColorPalette: Colors = [];

  constructor(
    private readonly store: Store,
    private readonly shapeService: ShapeService,
  ) {
    this.orgColorPalette$ = this.store.select(getCurrentOrgColorPalette).pipe(
      map(object => {
        const arr = Object.entries(object || {})
          .filter(([, value]) => !!value)
          .map(([name, code]) => ({
            name,
            code,
            hover: false,
          }));
        this.orgColorPalette = arr;
        return arr;
      }),
    );

    this.store
      .select(getCurrentColorPalette)
      .subscribe(colorPalette => (this.colorPalette = cloneDeep(colorPalette)));

    this.palette$ = this.store.select(getCurrentColorPalette).pipe(
      map(object => {
        const arr = Object.entries(object || {})
          .filter(([, value]) => !!value)
          .map(([name, code]) => ({
            name,
            code,
            hover: false,
          }));
        this.palette = arr;
        return arr;
      }),
    );

    this.palette$.subscribe(palette => {
      this.palette = palette;
    });
  }

  navigateToOrgSettings() {
    this.shapeService.navigateToOrgIndex('settings');
  }

  addNewItem() {
    // this.store.dispatch(
    //   setColorPaletteItem({ name: 'newColor', color: '#333333' }),
    // );
  }

  nameChanged(value: string, index: number) {
    this.palette[index].name = value;
    this.save();
  }

  colorChanged(value: string, index: number) {
    this.palette[index].code = value;
    console.log('colorChanged', this.palette);
    // this.save();
  }

  get langKeys() {
    return ['hu', 'en', 'ger', 'esp', 'fr', 'it', 'pl'].filter(
      key => !this.languages.includes(key),
    );
  }

  addColor() {
    this.palette.push({ name: 'newColor', code: '#333333' });
    this.colorPalette['newColor'] = '#333333';
    console.log('colorPalette', this.colorPalette);
    this.save();
  }

  save() {
    console.log('save');
    const colorPalette = this.palette.reduce(
      (acc, { name, code }) => ({ ...acc, [name]: code }),
      {},
    );
    console.log('save', colorPalette);
    this.store.dispatch(saveProjectColorPalette({ colorPalette }));
  }

  removeProjectColor(index: number, event: MouseEvent) {
    event.stopPropagation();
    if (index > -1 && index < this.palette.length) {
      this.palette.splice(index, 1);
      this.save();
    }
  }

  removeOrgColor(index: number, event: MouseEvent) {
    event.stopPropagation();
    if (index > -1 && index < this.orgColorPalette.length) {
      this.orgColorPalette.splice(index, 1);
      // TODO: Save org palette to store if needed
    }
  }
}
